<template>
  <div>
    <vue-dropzone
      @vdropzone-sending="vsending"
      ref="dropzone"
      id="dropzone"
      :options="dropzoneOptions"
      :useCustomSlot="true"
      @vdropzone-success="onSuccess"
      :key="url"
    >
      <!-- <vue-dropzone @vdropzone-sending="vsending" ref="dropzone" id="dropzone"
            action="https://graduados.udh.edu.pe/apigraduados/api/prueba" :options="dropzoneOptions"
            :useCustomSlot=true
             :key="url" 
            > -->
      <div class="dropzone-custom-content">
        <h3 class="dropzone-custom-title">
          Haga click y seleccione las imágenes a cargar.
        </h3>
        <div class="subtitle">...o solo arrástrelo aqui desde su pc</div>
      </div>
    </vue-dropzone>
    <button
      type="button"
      class="btn btn-block btn-indigo text-white"
      @click.prevent="subiendoFoto()"
    >
      <i class="fa fa-upload"></i> Subir Imágenes
    </button>
    <div id="template-preview">
      <div class="dz-preview dz-file-preview well" id="dz-preview-template">
        <div class="dz-details">
          <div class="dz-filename"><span data-dz-name></span></div>
          <div class="dz-size" data-dz-size></div>
        </div>
        <div class="dz-progress">
          <span class="dz-upload" data-dz-uploadprogress></span>
        </div>
        <div class="dz-success-mark"><span></span></div>
        <div class="dz-error-mark"><span></span></div>
        <div class="dz-error-message"><span data-dz-errormessage></span></div>
      </div>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
const getTemplate = () => `
<div style='width:120px;display:inline;float:left;margin-left:40px' >
\n  <textarea id='descripcion' name='descripcion[]' rows='3' style='width:150px;margin-left:0px'  placeholder='Escriba una descripción aquí.' class='descripcion form-control' ></textarea> 
<div class="dz-preview dz-file-preview">

  <div class="dz-image">
    <div data-dz-thumbnail-bg></div>
    
    <img data-dz-thumbnail="">
  </div>
  <div class="dz-details">
    <div class="dz-size"><span data-dz-size></span></div>
    <div class="dz-filename"><span data-dz-name></span></div>
  </div>
  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
  <div class="dz-error-message"><span data-dz-errormessage></span></div>
  <div class="dz-success-mark"><i class="fa fa-check"></i></div>
  <div class="dz-error-mark"><i class="fa fa-close"></i></div>
</div>
</div>
`;

export default {
  name: "Dropzone",
  props: ["url"],
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      dropzoneOptions: {
        // url: this.URL_BASE() + 'fotos/create/' + this.codeQr,
        url: this.url,
        withCredentials: false,
        method: "post",
        addRemoveLinks: true,
        previewTemplate: getTemplate(),
        uploadMultiple: true,
        maxFilesize: 7,
        paramName: "file",
        createImageThumbnails: true,
        maxThumbnailFilesize: 10,
        thumbnailWidth: 120,
        thumbnailHeight: 120,
        filesizeBase: 4000,
        maxFiles: 15,
        // params: {'descripcion[]':document.getElementsByClassName('descripcion')},
        clickable: true,
        ignoreHiddenFiles: true,
        acceptedFiles: "image/jpeg, image/jpg, image/png",
        acceptedMimeTypes: null,
        autoProcessQueue: false,
        autoQueue: true,
        dictRemoveFile: " &times; Remover foto",
        dictRemoveFileConfirmation:
          "¿Seguro que desea remover esta fotografía?",
        dictMaxFilesExceeded: "Tu no puedes subir más fotografías.",
        headers: {
          Accept: "application/json",
          "Cache-Control": "no-cache",
          "X-Requested-With": "XMLHttpRequest",
          // "Authenticate": this.API_KEY()
        },
      },
    };
  },

  methods: {
  handlePaste(event) {
      // Obtenemos los items del portapapeles
      const items = (event.clipboardData || event.originalEvent.clipboardData).items;
      
      for (let index in items) {
        const item = items[index];
        
        // Verificamos si el item es un archivo y si es una imagen
        if (item.kind === 'file' && item.type.indexOf('image/') !== -1) {
          const file = item.getAsFile();
          
          // Agregamos el archivo manualmente a la instancia de Dropzone
          // Nota: 'dropzone' es la ref que pusiste en el template: ref="dropzone"
          this.$refs.dropzone.addFile(file);
        }
      }
    },
    vsending(file, xhr, formData) {
      this.sending = true;
      var str = file.previewElement.querySelector(".descripcion").value;
      formData.append("descripcion[]", str);
      // window.toastr.warning('', 'Event : vdropzone-sending')
    },
    onSuccess(file, response) {
      // `file` es el archivo que se ha cargado
      // `response` es la respuesta del servidor
      // Emitir un evento personalizado al componente padre
      this.$emit("cargarFotos", "ey");
      // Opcional: emitir una notificación al usuario
      // this.$emit('notificacion', `La foto ${file.name} se ha cargado correctamente.`);
    },
    subiendoFoto() {
      let lleno = true;
      var chkAsientos = document.getElementsByClassName("descripcion");
      for (var i = 0; i < chkAsientos.length; i++) {
        if (chkAsientos[i].value == "") {
          lleno = false;
        }
      }

      if (lleno) {
        this.$refs.dropzone.processQueue();
        var self = this;
         setTimeout(() => {
            //  this.cargarEvidencia();
            // self.$emit("cargarFotos", "ey");

        }, 5000);
        setTimeout(() => {
          //  this.cargarEvidencia()
          this.$emit("cargarFotos", "ey"); // Esto ahora funciona correctamente
          this.$refs.dropzone.removeAllFiles();
        }, 30000);
      } else {
        alert("Ingrese la descripción a las fotos");
      }
    },
  },
  mounted() {
    // Escucha el evento "pegar" en cualquier parte de la ventana
    document.addEventListener("paste", this.handlePaste);
  },
  beforeDestroy() {
    // Es importante limpiar el evento cuando el componente se destruye
    document.removeEventListener("paste", this.handlePaste);
  },
  watch: {
    url(newQuestion, oldQuestion) {
      this.dropzoneOptions.url = newQuestion;
    },
  },
};
</script>